import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetConnectNextSteps as GetConnectNextStepsQuery,
    GetConnectNextSteps_connectNextSteps as ConnectNextSteps,
} from 'nutshell-graphql-types';

import GET_CONNECT_NEXT_STEPS from '../queries/get-connect-next-steps.graphql';

export const useGetConnectNextSteps = (): {
    connectNextSteps: ConnectNextSteps | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetConnectNextStepsQuery, Record<any, any>>(
        GET_CONNECT_NEXT_STEPS,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    return {
        connectNextSteps: data && data.connectNextSteps,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
